import React, { useEffect, useState } from "react";
import Layout from "../Component/Layout";
import CharacteristicsModal from "../Component/CharacteristicsModal ";
import * as XLSX from "xlsx";

const ConsumptionDashboard = () => {

  const [tableData, setTableData] = useState([]);
  const [productCodes, setProductCodes] = useState([]);
  const [storageBins, setStorageBins] = useState([]);

  const [filters, setFilters] = useState({
    product_code: "",
    storage_bin: "",
    year: "",
    month: "",
    from: "",
    to: "",
  });

  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const styles = {
    tableContainer: {
      background: "#ffffff",
      borderRadius: 8,
      padding: 12,
      boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
    },
    erpTable: {
      width: "100%",
      borderCollapse: "collapse",
    },
    erpTh: {
      background: "#f8fafc",
      fontSize: 13,
      fontWeight: 600,
      padding: "10px 12px",
      borderBottom: "1px solid #e5e7eb",
      color: "#1e293b",
    },
    erpTd: {
      fontSize: 13,
      padding: "10px 12px",
      borderBottom: "1px solid #f1f5f9",
      color: "#334155",
      textAlign: "center",
    },
  };

  // ================= LOAD =================
  useEffect(() => {
    fetchProductCodes();
    fetchStorageBins();
    fetchYears();
  }, []);

  useEffect(() => {
    fetchTable();
  }, [filters]);

  // ================= FETCH =================
  const fetchTable = async () => {
    let url = "https://master.erp.sbeecables.com/api/consumptiondashboard/data";

    const params = new URLSearchParams(filters).toString();
    if (params) url += `?${params}`;

    const res = await fetch(url);
    const data = await res.json();
    setTableData(data);
  };

  const fetchProductCodes = async () => {
    const res = await fetch("https://master.erp.sbeecables.com/api/consumptiondashboard/product-codes");
    const data = await res.json();
    setProductCodes(data);
  };

  const fetchStorageBins = async () => {
    const res = await fetch("https://master.erp.sbeecables.com/api/consumptiondashboard/storage-bins");
    const data = await res.json();
    setStorageBins(data);
  };

  // ================= HANDLER =================
  const handleChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value,
    });
  };

  // RESET
  const handleReset = () => {
    setFilters({
      product_code: "",
      storage_bin: "",
      year: "",
      month: "",
      from: "",
      to: "",
    });
  };

  // EXPORT FULL TABLE
  const handleExport = async () => {
    try {
      const res = await fetch(
        "https://master.erp.sbeecables.com/api/consumptiondashboard/export-all"
      );
      const data = await res.json();

      if (!data.length) {
        alert("No data to export");
        return;
      }

      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Goods Receipt");

      XLSX.writeFile(workbook, "Goods_Receipt.xlsx");
    } catch (err) {
      console.error("Export error:", err);
    }
  };
const openModal = async (row) => {
  try {
    const res = await fetch(
      `https://master.erp.sbeecables.com/api/consumptiondashboard/batch-details?product_code=${row.product_code}&batch_number=${row.batch_number}`
    );

    const data = await res.json();

    console.log("FULL DATA:", data); // 👈 check this

    setSelectedRow(data);   // ✅ IMPORTANT CHANGE
    setShowModal(true);

  } catch (err) {
    console.error("Modal error:", err);
  }
};


    const fetchYears = async () => {
        const res = await fetch(
            "https://master.erp.sbeecables.com/api/consumptiondashboard/years"
        );

        const data = await res.json();

        setYears(data);
    };
  const closeModal = () => {
    setShowModal(false);
    setSelectedRow(null);
  };

  // DATA
  const [years, setYears] = useState([]);

  const months = [
    { name: "January", value: 1 },
    { name: "February", value: 2 },
    { name: "March", value: 3 },
    { name: "April", value: 4 },
    { name: "May", value: 5 },
    { name: "June", value: 6 },
    { name: "July", value: 7 },
    { name: "August", value: 8 },
    { name: "September", value: 9 },
    { name: "October", value: 10 },
    { name: "November", value: 11 },
    { name: "December", value: 12 },
  ];

  // ================= UI =================
  return (
    <Layout>
      <div className="container-fluid p-4">

        <h4 className="fw-bold mb-1">Consumption Dashboard</h4>
        <p className="text-muted mb-4">
          View consumption and stock details
        </p>

        {/* DATE FILTER */}
        <div className="bg-white p-3 rounded-4 shadow-sm mb-3">
          <div className="row g-3 mt-2">

            <div className="col-md-2">
  <label className="form-label small">Year</label>
  <select
    name="year"
    className="form-select form-select-sm"
    value={filters.year}
    onChange={handleChange}
  >
                <option value="">Select</option>
                              {years.map((item, i) => (
                                  <option
                                      key={i}
                                      value={item.year}
                                  >
                                      {item.year}
                                  </option>
                              ))}
              </select>
            </div>

            <div className="col-md-2">
  <label className="form-label small">Month</label>
  <select
    name="month"
    className="form-select form-select-sm" value={filters.month} onChange={handleChange}>
                <option value="">Select</option>
                {months.map((m, i) => (
                  <option key={i} value={m.value}>{m.name}</option>
                ))}
              </select>
            </div>

            <div className="col-md-2">
  <label className="form-label small">From</label>
  <input
    type="date"
    name="from"
    className="form-control form-control-sm" value={filters.from} onChange={handleChange} />
            </div>

                      <div className="col-md-2">
                          <label className="form-label small">To</label>
                          <input
                              type="date"
                              name="to"
                              className="form-control form-control-sm" value={filters.to} onChange={handleChange} />
                      </div>

          </div>
        </div>

        {/* FILTERS */}
        <div className="bg-white p-3 rounded-4 shadow-sm mb-3">
          <div className="row g-3 mt-2">

            <div className="col-md-3">
              <label>Product Code</label>
              <select name="product_code" className="form-select" value={filters.product_code} onChange={handleChange}>
                <option value="">Select</option>
                {productCodes.map((item, i) => (
                  <option key={i} value={item.product_code}>
                    {item.product_code}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-3">
              <label>Storage Bin</label>
              <select name="storage_bin" className="form-select" value={filters.storage_bin} onChange={handleChange}>
                <option value="">Select</option>
                {storageBins.map((item, i) => (
                  <option key={i} value={item.storage_bin}>
                    {item.storage_bin}
                  </option>
                ))}
              </select>
            </div>

                      <div className="col-md-2 d-flex align-items-end">
                          <button
                              className="btn btn-sm w-100"
                              style={{
                                  background: "#0047AB",
                                  color: "#fff",
                                  border: "1px solid #0047AB"
                              }}
                              onClick={handleReset}
                          >
                              Reset
                          </button>
                      </div>
          </div>
        </div>

        {/* EXPORT BUTTON */}
        <div className="d-flex justify-content-end mb-2">
          <button
            onClick={handleExport}
            style={{
              backgroundColor: "#0047AB",
              color: "#fff",
              border: "none",
              padding: "8px 16px",
              borderRadius: 6,
              cursor: "pointer",
            }}
          >
            Export
          </button>
        </div>

        {/* TABLE */}
        <div style={styles.tableContainer}>
          <div className="table-responsive">

            <table className="table" style={styles.erpTable}>
              <thead>
                <tr>
                  <th style={styles.erpTh}>Product Code</th>
                  <th style={styles.erpTh}>Batch Number</th>
                  <th style={styles.erpTh}>Received Quantity</th>
                  <th style={styles.erpTh}>UOM</th>
                  <th style={styles.erpTh}>Storage Bin</th>
                  <th style={styles.erpTh}>Consumed</th>
                  <th style={styles.erpTh}>Remaining Quantity</th>
                </tr>
              </thead>

              <tbody>
                {tableData.map((row, index) => (
                  <tr key={index}>

                    <td style={styles.erpTd}>{row.product_code}</td>

                    <td style={styles.erpTd}>
                      <span>{row.batch_number}</span>
                      <span
                        onClick={() => openModal(row)}
                        style={{ cursor: "pointer", marginLeft: 6 }}
                      >
                        ▶
                      </span>
                    </td>

                    <td style={styles.erpTd}>{row.received_qty}</td>
                    <td style={styles.erpTd}>{row.uom}</td>
                    <td style={styles.erpTd}>{row.storage_bin}</td>

                    <td style={styles.erpTd}>
                      {Number(row.consumed).toFixed(3)}
                    </td>

                    <td style={styles.erpTd}>
                      {Number(row.remaining_qty).toFixed(3)}
                    </td>

                  </tr>
                ))}
              </tbody>

            </table>
          </div>
        </div>

        {/* MODAL */}
        {showModal && (
          <CharacteristicsModal
            modalVisible={showModal}
            handleClose={closeModal}
            isEditing={false}
            title="Batch Details"
            selectedCharacteristics={
  selectedRow
    ? Object.entries(selectedRow).map(([key, value]) => ({
        characteristic: key,
        value: value ?? "-"
      }))
    : []
}
          />
        )}

      </div>
    </Layout>
  );
};

export default ConsumptionDashboard;